import cn from 'classnames/bind';
import React, { FC, PropsWithChildren } from 'react';

import { BaseButtonColor, BaseButtonProps } from './BaseButton.types';
import styles from './BaseButton.module.css';

const cx = cn.bind(styles);

export const BaseButton: FC<PropsWithChildren<BaseButtonProps>> = (props) => {
    const {
        onClick,
        children,
        isAnimated = false,
        animationDuration = 5,
        color = BaseButtonColor.gray,
        withIcon = false,
        className,
    } = props;

    return (
        <button
            className={cx('button', color, className, {
                withIcon,
            })}
            onClick={onClick}
        >
            <span
                className={cx(isAnimated && 'button_animated')}
                style={{ animationDuration: `${animationDuration}s` }}
            />
            {children}
        </button>
    );
};
